var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagMarshallIsland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8365 32 32 24.8365 32 16C32 13.3148 31.3375 10.7846 30.1686 8.5625L15.9812 16.0187L23.4375 1.83138C21.2154 0.6625 18.6852 0 16 0C7.1635 0 0 7.1635 0 16C0 20.4183 1.79088 24.4183 4.68625 27.3137C7.58169 30.2092 11.5817 32 16 32Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1522 8.57995C29.4198 7.18595 28.4676 5.87714 27.2955 4.70501C26.1233 3.53289 24.8147 2.5807 23.4205 1.84839L4.66797 27.3325L30.1522 8.57995Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66797 27.3325L30.1522 8.58002C29.4198 7.18602 28.4676 5.8772 27.2955 4.70508L4.66797 27.3325Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8942 9.38275L11.9402 10.3019L12.9808 12.1944L10.8589 11.7884L10.5901 13.9319L9.11205 12.3554L7.63405 13.9319L7.3653 11.7884L5.24343 12.1942L6.28386 10.3018L4.32986 9.38275L6.28393 8.46356L5.24343 6.57118L7.36518 6.977L7.63411 4.8335L9.11205 6.41006L10.5901 4.8335L10.8589 6.977L12.9809 6.57118L11.9403 8.46362L13.8942 9.38275Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMarshallIsland);
export default __webpack_public_path__ + "static/media/flag_marshall_island.5df56507023b78bf81f47fc2f48cf41c.svg";
export { ForwardRef as ReactComponent };